import { IFrame } from '@/components/IFrame';

export interface Props {
  url: string;
  handleFetchPortfolioList: () => void;
  handleIFrameRouteChangingEvent: (data: { path: string }) => void;
}

const ImportPortfolio = ({
  url,
  handleFetchPortfolioList,
  handleIFrameRouteChangingEvent,
}: Props) => {
  return (
    <IFrame
      id="import-portfolio"
      url={url}
      isOtpRequired
      loadingText={'Please wait.. Loading content..'}
      unMountOperations={handleFetchPortfolioList}
      handleIFrameRouteChangingEvent={handleIFrameRouteChangingEvent}
    />
  );
};

export default ImportPortfolio;
